module.exports = __webpack_public_path__ + "static/media/shjrst.64d597c6.png";